import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntModule } from 'vhobjects-service';
import { MaterialModule } from 'vhobjects-service';

import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AtwCountdownAdmin } from './objects/basic/countdown/admin/countdown-admin/countdown-admin.component';
import { MenuProductAdminComponent } from './objects/product/menu-product/admin/menu-product/menu-product.component';
import { AtwMessengerAdmin } from './objects/difference/messenger/admin/messenger.component';

import { AtwZaloShareAdminButton } from './objects/difference/zalo-share/admin/button/zalo-share-admin-button.component';
import { AtwZaloFollowAdminButton } from './objects/difference/zalo-follow/admin/button/zalo-follow-admin-button.component';

import { AtwMenuHorizontalAdmin } from './objects/menu/menu-horizontal/admin/menu-horizontal-admin/menu-horizontal-admin.component';
import { AddMenuHeaderAdminComponent } from './objects/menu/menu-horizontal/admin/menu-horizontal-admin/add-menu-header-admin/add-menu-header-admin.component';
import { AddSubMenuHeaderAdminComponent } from './objects/menu/menu-horizontal/admin/menu-horizontal-admin/add-sub-menu-header-admin/add-sub-menu-header-admin.component';
import { EditMenuHeaderAdminComponent } from './objects/menu/menu-horizontal/admin/menu-horizontal-admin/edit-menu-header-admin/edit-menu-header-admin.component';
import { EditSubMenuHeaderAdminComponent } from './objects/menu/menu-horizontal/admin/menu-horizontal-admin/edit-sub-menu-header-admin/edit-sub-menu-header-admin.component';
import { AtwMenuVerticalAdmin } from './objects/menu/menu-vertical/admin/menu-vertical-admin/menu-vertical-admin.component';
import { AddMenuVerticalAdminComponent } from './objects/menu/menu-vertical/admin/menu-vertical-admin/add-menu-vertical--admin/add-menu-vertical-admin.component';
import { AddSubMenuVerticalAdminComponent } from './objects/menu/menu-vertical/admin/menu-vertical-admin/add-sub-menu-vertical-admin/add-sub-menu-vertical-admin.component';
import { EditMenuVerticalAdminComponent } from './objects/menu/menu-vertical/admin/menu-vertical-admin/edit-menu-vertical-admin/edit-menu-vertical-admin.component';
import { EditSubMenuVerticalAdminComponent } from './objects/menu/menu-vertical/admin/menu-vertical-admin/edit-sub-menu-vertical-admin/edit-sub-menu-vertical-admin.component';
import { AtwTextParagraphAdmin } from './objects/basic/text-paragraph/admin/text-paragraph/text-paragraph-admin.component';
import { TranslateModule } from '@ngx-translate/core';
import { AtwVideoUploadAdmin } from './objects/basic/video-upload/admin/video-upload/video-upload.component';
import { AtwImageBeforeAfterSliderAdmin } from './objects/basic/image-before-after-slider/admin/image-before-after-slider-admin/image-before-after-slider-admin.component';
import { ImageUploadOptionConfigModule } from 'vhobjects-service';
import { VhLanguagePipeModule } from './vh-language.pipe';
import { AtwMultiLanguageAdmin } from './objects/basic/multi-language/admin/multi-language-admin/multi-language-admin.component';
import { AtwFlipBookAdmin } from './objects/basic/flip-book/admin/flip-book-admin.component';
import { SelectLanguageConfigModule } from './select-language-config/select-language-config.module';
import { EditShapeComponent } from './objects/basic/shape/edit-shape/edit-shape.component';
import { AtwImageDetailRepeatAdmin } from './objects/basic/image-detail-repeat/admin/image-detail-repeat-admin/image-detail-repeat-admin.component';
import { AtwContentPreviewSliderAdmin } from './objects/basic/content-preview-slider/admin-config/content-preview-slider-admin-config/content-preview-slider-admin/content-preview-slider-admin.component';


const component = [
    AtwVideoUploadAdmin,
    MenuProductAdminComponent,
    AtwCountdownAdmin,

    AtwMessengerAdmin,
    AtwZaloShareAdminButton,
    AtwZaloFollowAdminButton,

    AtwMenuHorizontalAdmin,
    AtwMenuVerticalAdmin,
    AtwTextParagraphAdmin,
    AtwImageBeforeAfterSliderAdmin,
    AtwMultiLanguageAdmin,
    AtwFlipBookAdmin,
    AtwImageDetailRepeatAdmin
];


@NgModule({
    declarations: [component, AddMenuHeaderAdminComponent,
        AddSubMenuHeaderAdminComponent,
        EditMenuHeaderAdminComponent,
        EditSubMenuHeaderAdminComponent,
        AddMenuVerticalAdminComponent, AddSubMenuVerticalAdminComponent,
        EditMenuVerticalAdminComponent, EditSubMenuVerticalAdminComponent,
        EditShapeComponent,
        AtwContentPreviewSliderAdmin
    ],
    entryComponents: [component],
    imports: [
        CommonModule,
        FormsModule,
        NgZorroAntModule,
        ReactiveFormsModule,
        RouterModule,
        MaterialModule,
        CKEditorModule,
        TranslateModule, ImageUploadOptionConfigModule,
        VhLanguagePipeModule,
        SelectLanguageConfigModule
    ],
    exports: [component]
})
export class ObjectAdminComponentModule { }
